/* TJÅKKO navigation v3 "Skohyllan" (snippets/tj-nav.liquid). Ported from the approved mockup
   outputs/tjakko/mockups/navigation-redesign-v3/src/app.js.
   Desktop: a real mouse opens a panel on hover; a tap or a key press on the item is a plain toggle.
   Arrow keys move along the row, ArrowDown enters a panel, Tab walks into the open panel, Escape closes.
   Drawer: Dam/Herr/Barn switch, L2 screens that slide in from the right (main list inert while one is open). */
(() => {
  if (customElements.get('tj-nav')) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class TjNav extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      if (this.dataset.variant === 'desktop') this.initDesktop();
      else this.initDrawer();
      this.querySelectorAll('.tjn-shelf--scroll').forEach((s) => {
        s.addEventListener('scroll', () => s.classList.toggle('is-scrolled', s.scrollLeft > 8), { passive: true });
      });
    }

    /* ---------------- desktop ---------------- */
    initDesktop() {
      this.links = [...this.querySelectorAll('.tjn-nav__link[data-panel]')];
      this.navAll = [...this.querySelectorAll('.tjn-nav .tjn-nav__link')];
      this.panels = this.querySelector('.tjn-panels');
      this.dim = this.querySelector('.tjn-dim');
      this.openLink = null;
      let openTimer = null;
      let closeTimer = null;
      const scheduleClose = () => { clearTimeout(closeTimer); closeTimer = setTimeout(() => this.closeAll(), 180); };

      this.links.forEach((link) => {
        link.addEventListener('pointerenter', (e) => {
          if (e.pointerType !== 'mouse') return;
          clearTimeout(closeTimer); clearTimeout(openTimer);
          openTimer = setTimeout(() => { if (this.openLink !== link) { this.openPanel(link); this.openedBy = 'hover'; } }, this.openLink ? 40 : 120);
        });
        link.addEventListener('pointerleave', (e) => {
          if (e.pointerType !== 'mouse') return;
          clearTimeout(openTimer); scheduleClose();
        });
        link.addEventListener('click', () => {
          clearTimeout(openTimer);
          if (this.openLink === link && this.openedBy === 'click') { this.closeAll(); return; }
          if (this.openLink !== link) this.openPanel(link);
          this.openedBy = 'click';
        });
        link.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowDown') {
            e.preventDefault(); this.openPanel(link); this.openedBy = 'click';
            const f = this.panelOf(link).querySelector('.tjn-shelf__link, .tjn-bi') || this.panelOf(link).querySelector('a');
            if (f) f.focus();
          }
          if (e.key === 'Tab' && !e.shiftKey && this.openLink === link) {
            const g = this.panelOf(link).querySelector('a');
            if (g) { e.preventDefault(); g.focus(); }
          }
        });
      });
      this.navAll.forEach((el) => el.addEventListener('keydown', (e) => {
        const k = this.navAll.indexOf(el);
        if (e.key === 'ArrowRight') { e.preventDefault(); (this.navAll[k + 1] || this.navAll[0]).focus(); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); (this.navAll[k - 1] || this.navAll[this.navAll.length - 1]).focus(); }
      }));
      /* leaving the panel by keyboard: close it and continue at the next nav item */
      this.panels.addEventListener('keydown', (e) => {
        if (e.key !== 'Tab' || !this.openLink) return;
        const items = [...this.panelOf(this.openLink).querySelectorAll('a')].filter((a) => a.offsetParent !== null);
        const idx = this.navAll.indexOf(this.openLink);
        if (!e.shiftKey && document.activeElement === items[items.length - 1]) {
          e.preventDefault(); const nxt = this.navAll[idx + 1]; this.closeAll(); if (nxt) nxt.focus();
        } else if (e.shiftKey && document.activeElement === items[0]) {
          e.preventDefault(); this.openLink.focus();
        }
      });
      this.panels.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') clearTimeout(closeTimer); });
      this.panels.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') scheduleClose(); });
      this.dim.addEventListener('click', () => this.closeAll());
      document.addEventListener('click', (e) => {
        if (this.openLink && !e.target.closest('.tjn-nav') && !e.target.closest('.tjn-panels')) this.closeAll();
      });
      document.addEventListener('focusin', (e) => {
        if (this.openLink && !e.target.closest('.tjn-panels') && !e.target.closest('.tjn-nav')) this.closeAll();
      });
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape' || !this.openLink) return;
        const l = this.openLink; this.closeAll(); l.focus();
      });
      window.addEventListener('resize', () => { if (this.openLink && !this.offsetParent) this.closeAll(); });

      /* brand index: hovering or focusing a name swaps the photo. A brand without a photo (or whose photo
         fails to load) shows the neutral tile: its name on the mist ground, never the previous brand's photo.
         Opening the panel again starts from the server state (client 2026-10-19). */
      const bImg = this.querySelector('[data-brand-img]');
      const bName = this.querySelector('[data-brand-name]');
      const bFeat = this.querySelector('[data-brand-feature]');
      const bLinks = [...this.querySelectorAll('.tjn-bi')];
      this.resetBrands = () => {};
      if (bImg && bName && bFeat) {
        const init = { src: bImg.getAttribute('src') || '', name: bName.textContent, href: bFeat.getAttribute('href') };
        const done = () => bFeat.classList.remove('is-loading');
        bImg.addEventListener('load', done);
        bImg.addEventListener('error', () => { done(); bFeat.classList.add('is-empty'); });
        const set = (src, name, href) => {
          bName.textContent = name;
          bFeat.setAttribute('href', href);
          bFeat.classList.toggle('is-empty', !src);
          if (src && bImg.getAttribute('src') !== src) {
            bFeat.classList.add('is-loading');
            bImg.setAttribute('src', src);
            if (bImg.complete && bImg.naturalWidth) done();
          }
        };
        let warm = false;
        const preload = () => {
          if (warm) return; warm = true;
          bLinks.forEach((a) => { if (a.dataset.img) { const i = new Image(); i.src = a.dataset.img; } });
        };
        bLinks.forEach((a) => {
          const show = () => {
            preload();
            bLinks.forEach((x) => x.classList.toggle('is-active', x === a));
            set(a.dataset.img || '', a.dataset.name, a.getAttribute('href'));
          };
          a.addEventListener('mouseenter', show);
          a.addEventListener('focus', show);
        });
        this.brandPanel = bFeat.closest('.tjn-panel');
        this.resetBrands = () => {
          bLinks.forEach((x) => x.classList.remove('is-active'));
          set(init.src, init.name, init.href);
        };
      }

      /* short placeholder where the search field narrows */
      const q = this.querySelector('.tjn-search--bar input');
      const mq = window.matchMedia('(max-width: 1320px)');
      const ph = () => { if (q) q.placeholder = mq.matches ? q.dataset.phShort : q.dataset.phLong; };
      ph(); mq.addEventListener('change', ph);
    }

    panelOf(link) { return this.querySelector('#' + link.dataset.panel); }

    openPanel(link) {
      if (this.openLink === link) return;
      const switching = !!this.openLink;
      if (this.openLink) {
        const old = this.panelOf(this.openLink);
        old.hidden = true; old.classList.remove('is-opening');
        this.openLink.setAttribute('aria-expanded', 'false');
      }
      const p = this.panelOf(link);
      if (p === this.brandPanel) this.resetBrands();
      p.hidden = false;
      if (!reduce && !switching) { void p.offsetWidth; p.classList.add('is-opening'); }
      link.setAttribute('aria-expanded', 'true');
      this.openLink = link;
      this.dim.hidden = false;
    }

    closeAll() {
      if (!this.openLink) return;
      const p = this.panelOf(this.openLink);
      p.hidden = true; p.classList.remove('is-opening');
      this.openLink.setAttribute('aria-expanded', 'false');
      this.openLink = null;
      this.openedBy = null;
      this.dim.hidden = true;
    }

    /* ---------------- drawer ---------------- */
    initDrawer() {
      this.mainScroll = this.querySelector('.tjn-d__scroll');
      this.subOpen = null;
      this.subTrigger = null;
      const segs = [...this.querySelectorAll('.tjn-seg__btn')];
      const groups = [...this.querySelectorAll('.tjn-dgroup')];

      // Capture phase: the theme's MenuDrawer binds every <button> in the drawer to "close submenu",
      // which shuts the whole drawer. Stop the click here and handle our own buttons.
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('button');
        if (!btn || !this.contains(btn)) return;
        e.stopPropagation();
        if (btn.type === 'submit') return; // language form: stop the theme's close handler, keep the submit
        e.preventDefault();
        if (btn.dataset.seg) {
          segs.forEach((x) => { x.classList.toggle('is-active', x === btn); x.setAttribute('aria-pressed', x === btn ? 'true' : 'false'); });
          groups.forEach((g) => { g.hidden = g.dataset.group !== btn.dataset.seg; });
        } else if (btn.dataset.sub) {
          this.openSub(btn);
        } else if (btn.hasAttribute('data-back')) {
          this.closeSub(false);
        }
      }, true);

      // Escape inside an L2 screen goes back one level instead of closing the drawer (the theme closes on keyup).
      const onEsc = (e) => {
        if (e.key !== 'Escape' || !this.subOpen) return;
        e.stopPropagation();
        if (e.type === 'keyup') this.closeSub(false);
      };
      this.addEventListener('keydown', onEsc);
      this.addEventListener('keyup', onEsc);

      // When the theme closes the drawer, reset to the first screen.
      const details = this.closest('details');
      if (details) {
        const sync = () => {
          const open = details.hasAttribute('open');
          document.body.classList.toggle('tjn-drawer-open', open);
          if (!open) this.closeSub(true);
        };
        new MutationObserver(sync).observe(details, { attributes: true, attributeFilter: ['open'] });
        sync();
      }
    }

    openSub(btn) {
      const sub = this.querySelector('#' + btn.dataset.sub);
      this.subTrigger = btn; this.subOpen = sub;
      sub.hidden = false; sub.scrollTop = 0;
      this.mainScroll.inert = true;
      btn.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => requestAnimationFrame(() => {
        sub.classList.add('is-open');
        sub.querySelector('.tjn-dback').focus({ preventScroll: true });
      }));
    }

    closeSub(instant) {
      if (!this.subOpen) return;
      const sub = this.subOpen;
      const btn = this.subTrigger;
      this.subOpen = null;
      sub.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false');
      this.mainScroll.inert = false;
      const done = () => { if (!sub.classList.contains('is-open')) sub.hidden = true; };
      if (instant || reduce) done(); else setTimeout(done, 260);
      if (!instant) btn.focus({ preventScroll: true });
    }
  }

  customElements.define('tj-nav', TjNav);
})();
